import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { CustomQuestion, CustomQuestionType, JoiEvent } from "globals/store/events.data";
import { ManageWrapperComponent, Tab, TabGroup } from "../../modules/manage/manage-wrapper.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AppSurvey, JoiAppInfo, SurveyOption, SurveyOptionTabNames, SurveyOptions, SurveySelectData, SurveySubmissionData } from "globals/store/app.data";
import { Wrapper } from "../../components/wrapper.component";
import { getSurveyListOfTimeZonesUsed, surveyReselector } from "../../store/reselectors/apps.reselector";
import { TimeZoneDetails } from "globals/store/programs.data";
import { ConfirmDeleteData, openConfirmDeleteGetResult } from "../../components/dialog.confirmDelete.component";
import { DotMenuEvent } from "../../components/misc/dot-menu.component";
import { editCustomQuestion } from "../performers/performerSharedFunctions";
import { CustomQuestionDialog, CustomQuestionDialogData } from "../../components/entities/custom-question.dialog.component";
import { createId } from "globals/helpers/helpers";
import { openDialogGetResult } from "../../helpers/angular-helpers";
import { CustomQuestionManagerViewComponent } from "src/app/components/entities/custom-question-manager-view.component";
import { CustomQuestionsComponent } from "src/app/components/entities/custom-questions.component";
import { TipTextComponent } from "src/app/components/misc/tip-text.component";
import { TimeSelectorComponent } from "./time-selector.component";
import { SurveyComponent } from "./survey.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'manage-survey',
    templateUrl: './manage-survey.html',
    styleUrls: ['../../modules/manage/manage-dialogs.scss', './manage-survey.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, CustomQuestionManagerViewComponent, CustomQuestionsComponent, TipTextComponent, TimeSelectorComponent,SurveyComponent, CommonModule],
})
export class ManageSurveyComponent extends Wrapper<ManageSurveyComponent>  {
  _file = 'manage-survey'
  labels;
  tabs = SurveyOptions
  event: JoiEvent
  tabGroups: TabGroup<SurveyOption>[] = [{ tabs: [
    { id: 'build', name: SurveyOptionTabNames.build },
    { id: 'preview', name: SurveyOptionTabNames.preview },
    { id: 'fillout', name: SurveyOptionTabNames.fillout }
  ]}]
  selectedTab: Tab<SurveyOption>
  appInfo: JoiAppInfo
  survey: AppSurvey
  timezones: TimeZoneDetails[] = []

  constructor(
    public dialogRef: MatDialogRef<ManageSurveyComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: SurveySelectData,
    public changeDetectorRef: ChangeDetectorRef
    ) {
    super()
    this.subProp(this.store.select('apps', 'entities', data.surveyId), 'appInfo')
    this.subProp(this.store.select('events', 'event'), 'event')   
    this.selectProp(surveyReselector, data, 'survey')
    this.selectProp(getSurveyListOfTimeZonesUsed, data, 'timezones')
    this.subProp(this.store.select('apps', 'entities', data.appId), 'appInfo')
  }

  async dotMenuSelection({ dotEvent, question }: { dotEvent: DotMenuEvent, question: CustomQuestion }) {
    const data: ConfirmDeleteData = {
      title: `Delete custom question`,
      para: 'All answers will also be lost if you delete this',
      rect: (dotEvent.event.target as HTMLButtonElement).getBoundingClientRect(),
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    const questions = this.survey.customQuestions.filter(q => q.id !== question.id)
    this.survey.customQuestions = questions
    this.saveSurvey()
  }

  changeTime(d: { UTCTime: number, timeZone: string }) {
    this.survey.pushTime = d.UTCTime
    this.survey.timeZone = d.timeZone
    this.saveSurvey()
  }

  saveSurvey() {
    this.appInfo.surveys[this.data.surveyId] = this.survey
    this.appService.updateAppInfo(this.appInfo)
  }

  changeTab(tab) {
    console.log({ tab })
    this.selectedTab = tab
  }

  updateTitle(title: string) {
    this.survey.title = title
    this.saveSurvey()
  }

  changeIdOrder(newIds: string[]) {
    this.survey.customQuestions = newIds.map(id => this.survey.customQuestions.find(q => q.id === id)).filter(q => !!q)
    this.saveSurvey()
  }

  async downloadSubmissions() {
    this.appService.downloadSubmissions({ eventId: this.event.eventId, appId: this.appInfo.id, surveyId: this.survey.id })
  }

  async editQuestion(question: CustomQuestion) {
    console.log("Should be editing... (not yet!)", question)

    const data: CustomQuestionDialogData = {
      type: null,
      dialogTitle: 'Edit Survey Question',
      position: null, // not working very well 
      typeIds: [],
      types: null,
      questionType: question.type,
      text: question.question,
    }
  
    const sameData = await openDialogGetResult(this.dialog, CustomQuestionDialog, { width: '590px', disableClose: true, data })
    if (!sameData) return // cancelled
  
    const oldQuestion = this.survey.customQuestions.find(q => q.id === question.id) // mutate in place
    oldQuestion.question = data.text
    this.saveSurvey()
  
  }

  async addQuestion(questionType: CustomQuestionType | undefined) {
    const data: CustomQuestionDialogData = {
      type: null,
      dialogTitle: 'New Survey Question',
      position: null, // not working very well 
      typeIds: [],
      types: null,
      questionType,
      text: '',
      isNew: true
    }
    const sameData = await openDialogGetResult(this.dialog, CustomQuestionDialog, { width: '590px', disableClose: true, data })
    if (!sameData) return // cancelled
    const question: CustomQuestion = {
      id: createId(),
      question: data.text,
      typeIds: [...data.typeIds],
      created: new Date().getTime(),
      type: data.questionType,
      isMandatory: !!data.isMandatory,
    }
    console.log({ question })
    this.survey.customQuestions.push(question)
    this.saveSurvey()
  }

  submitSurvey(submissionData: SurveySubmissionData) {
    this.appService.submitSurvey(submissionData)
  }

}
